import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/Rx';
import { environment } from '../../environments/environment'
var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
var httpOptions;
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
}

@Injectable({
  providedIn: 'root'
})
export class ViewRequestService {
  viewRequestURL = environment.viewRequestURL + "viewRequest?plantCode=";
  getAttachmentURL = environment.createRequestURL + "getAttachment?requestId="
  changeApproverURL = environment.createRequestURL + "changeApprover";
  getApproverNamesURL = environment.createRequestURL + "getChangeApproverUserList?userId=";
  resendToUserURL = environment.viewRequestURL + "updateResendRequest";

  constructor(private http: HttpClient) { }
  viewRequest(plantCode, requestId) {
    const url = this.viewRequestURL + plantCode + '&requestId=' + requestId
    return this.http.get(url, httpOptions)
      .map((response: any) => response).catch(this.handleError);
  }
  getAttachment(requestId) {
    const url = this.getAttachmentURL + requestId
    return this.http.get(url, httpOptions)
      .map((response: any) => response).catch(this.handleError);
  }

  getApproverList(userId,managerId) {
    const url = this.getApproverNamesURL+userId+'&managerId='+managerId;
    return this.http.get(url, httpOptions)
      .map((response: any) => response).catch(this.handleError);
  }
  changeApprover(contactObj): Observable<any> {
    const url = this.changeApproverURL;
    return this.http.post(url, contactObj, httpOptions)
      .map((response: any) => response).catch(this.handleError);
  }
  resendToUser(resendObj) {
    const url = this.resendToUserURL
    return this.http.post(url, resendObj, httpOptions)
      .map((response: any) => response).catch(this.handleError);
  }
  updatePreProduction(preProdData: any) {
    const url = environment.viewRequestURL + "updatePreProduction";
    return this.http.post(url, preProdData, httpOptions)
      .map((response: any) => response).catch(this.handleError);
  }
  private handleError(error: HttpErrorResponse) {
    console.log("error")
    var errorMsg = '';
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMsg = `An error occurred: ${error.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong
      errorMsg = `Backend returned code ${error.status}`;
    }
    // return an observable with a user-facing error message
    return throwError(errorMsg);
  }
}
